import * as React from "react";
import './FormDropdown.css'
import Icon from "../Icon/Icon";
import FormInput from "../FormInput/FormInput";
import {isMobile} from "react-device-detect";
import DropDownOption from "./DropDownOption";

interface ILocalState {
    isOpen: boolean;
    selectedValue: string;
    selectedLabel: string;
    otherReason: string
    showOtherTextBox: boolean
}

interface IOption {
    label: HTMLElement;
    value: any;
}

interface IProps {
    options?: IOption[];
    initialValue?: string
    isDisabled: boolean;
    selectCB: (val: string | boolean)=> void;
    placeholder: string;
}

export default class FormDropdown  extends React.Component<
    IProps,
    ILocalState
    > {
    public state: ILocalState = {
        isOpen: false,
        selectedValue: this.props.initialValue || "",
        showOtherTextBox: false,
        otherReason: "",
        selectedLabel: ""
    };

    public renderArrow = () => {
        const {isDisabled} = this.props;
        if (isDisabled) {
            return "greyArrowDown";
        }
        return this.state.isOpen ? 'blueArrowUp' : 'blueArrowDown';
    };

    public toggleArrow = () => {
        const {isDisabled} = this.props;
        if (isDisabled) {
            return;
        }
        const newState = this.state;
        newState.isOpen = !this.state.isOpen;
        newState.showOtherTextBox = false;
        this.setState(newState);
    };

    public updateSelection = (selectedoption: any) => {
        const {selectCB} = this.props;
        const value = selectedoption.value;
        const label = selectedoption.label;
        const newState = this.state;
        newState.selectedLabel = label;
        newState.isOpen = false;
        newState.selectedValue = value;
        if (value === "Other") {
            newState.showOtherTextBox = true;
            selectCB(false);
        } else {
            selectCB(value);
        }
        this.setState(newState);
    }

    public renderOptions = () => {
        const options = this.props.options!.map((option, index) => {
            return <DropDownOption
                key={index}
                value={option.value}
                label={option.label}
                isLast={index === this.props.options!.length - 1}
                isSelected={this.state.selectedValue === option.value}
                onOptionClick={this.updateSelection}/>
        });
        return (
            <div className="options-container">
                {options}
            </div>
        )
    };

    public updateOtherReason = (otherTextValue: any) => {
        const {selectCB} = this.props;
        if(otherTextValue.length >= 3) {
            selectCB(`${this.state.selectedLabel}: ${otherTextValue}`);
        }else {
            selectCB(false);
        }
    };

    public renderOtherTextBox = () => {
        const mobileStyle = isMobile? " mobile": "";
        return this.state.showOtherTextBox? <div className={"textbox-container" + mobileStyle}>
            <FormInput change={this.updateOtherReason} placeholder={"Write here..."}/>
        </div>: null;
    };

    public renderDropDown = () => {
        const {isDisabled, placeholder} = this.props;
        const placeholderClass = isDisabled? "dropdown-placeholder placeholder-disabled" : "dropdown-placeholder";
        const dropdownClass = this.state.isOpen || this.state.showOtherTextBox? "dropdown-header-open": "";
        return (
            <div className="dropdown-container">
                <div className={"dropdown-header " + dropdownClass} onClick={this.toggleArrow}>
                    <div className={placeholderClass}>{this.state.selectedLabel || placeholder}</div>
                    <div className="icon-container" ><Icon icon={this.renderArrow()}/></div>
                </div>
                {this.state.isOpen && !this.state.showOtherTextBox? this.renderOptions(): null}
            </div>
        );
    };

    public render() {
        return (
            <>
                {this.renderDropDown()}
                {this.renderOtherTextBox()}
            </>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/FormDropdown/FormDropdown.tsx